/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ErrorReportVO } from '../model';
// @ts-ignore
import { ErrorType } from '../model';
// @ts-ignore
import { TopicVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * MapioControllerApi - axios parameter creator
 * @export
 */
export const MapioControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ErrorType} type Typ hlášené chyby
         * @param {Array<ErrorReportVO>} errorReportVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createErrorReport: async (type: ErrorType, errorReportVO: Array<ErrorReportVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('createErrorReport', 'type', type)
            // verify required parameter 'errorReportVO' is not null or undefined
            assertParamExists('createErrorReport', 'errorReportVO', errorReportVO)
            const localVarPath = `/api/errorReport/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(errorReportVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topicId 
         * @param {TopicVO} topicVO Objekt topicu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopicFull: async (topicId: string, topicVO: TopicVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('updateTopicFull', 'topicId', topicId)
            // verify required parameter 'topicVO' is not null or undefined
            assertParamExists('updateTopicFull', 'topicVO', topicVO)
            const localVarPath = `/api/conf/topics/{topicId}`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MapioControllerApi - functional programming interface
 * @export
 */
export const MapioControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MapioControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ErrorType} type Typ hlášené chyby
         * @param {Array<ErrorReportVO>} errorReportVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createErrorReport(type: ErrorType, errorReportVO: Array<ErrorReportVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createErrorReport(type, errorReportVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topicId 
         * @param {TopicVO} topicVO Objekt topicu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTopicFull(topicId: string, topicVO: TopicVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopicVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTopicFull(topicId, topicVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MapioControllerApi - factory interface
 * @export
 */
export const MapioControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MapioControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ErrorType} type Typ hlášené chyby
         * @param {Array<ErrorReportVO>} errorReportVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createErrorReport(type: ErrorType, errorReportVO: Array<ErrorReportVO>, options?: any): AxiosPromise<void> {
            return localVarFp.createErrorReport(type, errorReportVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topicId 
         * @param {TopicVO} topicVO Objekt topicu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopicFull(topicId: string, topicVO: TopicVO, options?: any): AxiosPromise<TopicVO> {
            return localVarFp.updateTopicFull(topicId, topicVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MapioControllerApi - interface
 * @export
 * @interface MapioControllerApi
 */
export interface MapioControllerApiInterface {
    /**
     * 
     * @param {ErrorType} type Typ hlášené chyby
     * @param {Array<ErrorReportVO>} errorReportVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioControllerApiInterface
     */
    createErrorReport(type: ErrorType, errorReportVO: Array<ErrorReportVO>, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {string} topicId 
     * @param {TopicVO} topicVO Objekt topicu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioControllerApiInterface
     */
    updateTopicFull(topicId: string, topicVO: TopicVO, options?: any): AxiosPromise<TopicVO>;

}

/**
 * MapioControllerApi - object-oriented interface
 * @export
 * @class MapioControllerApi
 * @extends {BaseAPI}
 */
export class MapioControllerApi extends BaseAPI implements MapioControllerApiInterface {
    /**
     * 
     * @param {ErrorType} type Typ hlášené chyby
     * @param {Array<ErrorReportVO>} errorReportVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioControllerApi
     */
    public createErrorReport(type: ErrorType, errorReportVO: Array<ErrorReportVO>, options?: any) {
        return MapioControllerApiFp(this.configuration).createErrorReport(type, errorReportVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topicId 
     * @param {TopicVO} topicVO Objekt topicu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioControllerApi
     */
    public updateTopicFull(topicId: string, topicVO: TopicVO, options?: any) {
        return MapioControllerApiFp(this.configuration).updateTopicFull(topicId, topicVO, options).then((request) => request(this.axios, this.basePath));
    }
}
